import React, { useState, useEffect } from 'react';

// material-ui
import { Button, Switch } from '@mui/material';

// project imports

import { getAddons, updateAddon } from 'services/addonServices';
import { AddonTypeOption, activeOption } from 'constant/constant';
import { currencyFormat } from 'helper/NumberFormat';
import TableComponent from 'components/TopCourtComponents/Table/TableComponent';
import { TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';
import { TypeSelectOption } from 'components/TopCourtComponents/Input/NominalRangeFilter';
import AddonFilter from './addonFilter';
import { Link, useNavigate } from 'react-router-dom';
import { checkIsSAdmin } from 'helper/Admin';
import { getUrlCourtCode } from 'helper/Court';
import { getCourtPlace } from 'helper/LocalStorage';

const initFilter = {
    name: '',
    stockType: TypeSelectOption[0],
    stockMin: '',
    stockMax: '',
    type: [AddonTypeOption[0]],
    status: activeOption[1],
    placeIds: getCourtPlace().merchantId ? [] : [{label: getCourtPlace().name, value: getCourtPlace().id}],
    page: 0,
    limit: 20,
}

export default function AddOns() {

    const filterAddOns = localStorage.getItem("filter_add_ons") ? JSON.parse(localStorage.getItem("filter_add_ons")) : null
    const [rows, setRows] = useState([])
    const navigate = useNavigate()
    const [filter, setFilter] = useState(filterAddOns ? {
        ...filterAddOns, 
        placeIds: initFilter.placeIds,
        page: initFilter.page,
        limit: initFilter.limit
    } : initFilter)
    const [totalData, setTotalData] = useState(0)

    useEffect(() => {
        localStorage.setItem("filter_add_ons", JSON.stringify(filter))
        loadData()
    }, [filter])

    const loadData = async () => {
        try {
            let { data, error } = await getAddons({
                name: filter.name ? filter.name : '',
                type: filter.type ? filter.type.map(v => { return v.value }) : '',
                stockType: filter.stockType ? filter.stockType.value : '',
                stockMin: filter.stockMin ? filter.stockMin : '',
                stockMax: filter.stockMax ? filter.stockMax : '',
                placeIds: filter.placeIds ? filter.placeIds.map(v => { return v.value }) : '',
                isActive: filter.status ? filter.status.value : '',
                page: filter.page,
                limit: filter.limit,
            });
            if (error) throw error
            if (data) {
                setRows(data.listItem)
                setTotalData(data.totalItem)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const changeStatus = async (v) => {
        await updateAddon({
            ...v,
            _id: v._id, isActive: !v.isActive })
        loadData()
    }

    const valueCustomator = (row) => {
        return ({
            name: <Link className='span-link' to={`/${getUrlCourtCode()}/addon/edit/${row._id}`}>{row.name}</Link>,
            image: <img style={{ maxWidth: 100, maxHeight: 50 }} src={row.itemImages[0]} alt=''></img>,
            type: <TCLabel>{AddonTypeOption.find(v => v.value === row.type)?.label}</TCLabel>,
            price: <TCLabel>{currencyFormat(row.price)}</TCLabel>,
            stock: <TCLabel>{row.stock || '-'}</TCLabel>,
            status: <Switch onChange={() => { changeStatus(row) }} checked={row.isActive} />,
        })
    }

    const onChangeFilter = (e) => {
        setFilter(prev => ({
            ...prev,
            ...e
        }))
    }

    const clearFilter = () => {
        setFilter(initFilter)
    }

    return (
        <>
            {
                checkIsSAdmin() &&
                <Button sx={{ mb: 2 }} variant="contained" disableElevation onClick={() => {
                    navigate(`/${getUrlCourtCode()}/addon/add`)
                }}>Create Add-On</Button>
            }
            <AddonFilter filter={filter} onChangeFilter={onChangeFilter} clearFilter={clearFilter} />
            <TableComponent
                columns={[
                    { label: "Name" },
                    { label: "Image" },
                    { label: "Type" },
                    { label: "Price" },
                    { label: "Stock" },
                    { label: "Status" },
                ]}
                rows={rows}
                valueCustomator={valueCustomator}
                pageChange={(e) => {
                    onChangeFilter({ page: e})
                }}
                totalData={totalData}
                page={filter.page}
            />
        </>
    )
}